export default "__VITE_ASSET__0531a909__"